export const PRODUCTION_BRANCH_ID = 'master';
export const PRODUCTION_BRANCH_NAME = 'main';
export const SCORECARD_LAYOUT_PATH = 'UserDefinedFiles\\Scorecard\\';
export const ANALYSIS_TEMPLATE_PATH = 'UserDefinedFiles\\AnalysisTemplates\\';

//# sourceMappingURL=maui.constants.js.map
